module.exports = __webpack_public_path__ + "static/clipboard-10d7a56e9fff639679275a95b9671d44.png";